import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle, CheckSquare, Compass } from 'lucide-react';
export function Slide6Market() {
  const insights = [{
    title: 'Biggest bottlenecks',
    icon: AlertTriangle,
    color: 'text-rose-500',
    bgColor: 'bg-rose-50',
    borderColor: 'border-rose-100',
    data: [{
      label: 'Isotope supply',
      value: 38.46
    }, {
      label: 'Scientific translation',
      value: 34.62
    }]
  }, {
    title: 'CRO/CDMO selection criteria',
    icon: CheckSquare,
    color: 'text-emerald-500',
    bgColor: 'bg-emerald-50',
    borderColor: 'border-emerald-100',
    data: [{
      label: 'Scientific expertise',
      value: 39.13
    }, {
      label: 'Integrated capabilities',
      value: 26.09
    }]
  }, {
    title: 'Future critical capability',
    icon: Compass,
    color: 'text-indigo-500',
    bgColor: 'bg-indigo-50',
    borderColor: 'border-indigo-100',
    data: [{
      label: 'Supply chain reliability',
      value: 37.5
    }, {
      label: 'Translational expertise',
      value: 25.0
    } // Estimated for visual
    ],
    note: 'Translational expertise and integrated workflows also ranked highly'
  }];
  return <div className="flex flex-col h-full max-w-[1600px] mx-auto w-full" data-id="element-631">
      <div className="mb-10" data-id="element-632">
        <h2 className="text-4xl font-display font-bold text-slate-900 mb-4" data-id="element-633">
          The market signal was clear
        </h2>
        <p className="text-xl text-slate-500 max-w-4xl" data-id="element-634">
          The audience pointed to a consistent set of priorities in radiopharma
          development: supply, translation, expertise, integration, and
          reliability.
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 flex-1" data-id="element-635">
        {insights.map((card, i) => {
        const Icon = card.icon;
        return <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2 + i * 0.15
        }} className={`bg-white rounded-3xl p-8 border ${card.borderColor} shadow-sm flex flex-col`} data-id="element-636">
              <div className={`w-12 h-12 rounded-xl ${card.bgColor} ${card.color} flex items-center justify-center mb-6`} data-id="element-637">
                <Icon className="w-6 h-6" data-id="element-638" />
              </div>

              <h3 className="text-xl font-bold text-slate-800 mb-8" data-id="element-639">
                {card.title}
              </h3>

              <div className="space-y-6 flex-1" data-id="element-640">
                {card.data.map((item, j) => <div key={j} data-id="element-641">
                    <div className="flex justify-between text-sm font-medium mb-2" data-id="element-642">
                      <span className="text-slate-700" data-id="element-643">{item.label}</span>
                      <span className="text-slate-900 font-bold" data-id="element-644">
                        {item.value}%
                      </span>
                    </div>
                    <div className="h-2 bg-slate-100 rounded-full overflow-hidden" data-id="element-645">
                      <motion.div initial={{
                  width: 0
                }} animate={{
                  width: `${item.value}%`
                }} transition={{
                  duration: 1,
                  delay: 0.5 + i * 0.2 + j * 0.1
                }} className={`h-full rounded-full ${j === 0 ? 'bg-slate-800' : 'bg-slate-400'}`} data-id="element-646" />
                    </div>
                  </div>)}
              </div>

              {card.note && <div className="mt-6 pt-6 border-t border-slate-100 text-sm text-slate-500 italic" data-id="element-647">
                  {card.note}
                </div>}
            </motion.div>;
      })}
      </div>
    </div>;
}